// DownloadMenu.tsx (3 dot Kebab Menu button to download the XLS and PNG)
import React, { useState, useEffect, useRef } from 'react';
import { downloadImage, downloadXLS } from 'utils/download';

type DownloadXLSParams = {
  filename: string;
  headers: Array<string>;
  labels: Array<string>;
  columns: Array<Array<number | string>>;
};

interface DownloadMenuProps {
  id: string;
  menuClass?: string;
  onDownloadXLS?: () => void;
  XLSParams?: DownloadXLSParams;
  imageParam?: string;
  onDownloadImage?: () => void;
}

const DownloadMenu = ({
  id,
  onDownloadXLS,
  XLSParams,
  imageParam,
  menuClass = '',
}: DownloadMenuProps) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        closeDropdown();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="flex items-center" ref={dropdownRef} id={id}>
      <img
        src={`${process.env.PUBLIC_URL}/static/img/dots-vertical.svg`}
        alt="dots"
        className="h-6 w-6 mr-4 cursor-pointer"
        onClick={toggleDropdown}
      />
      {isDropdownOpen && (
        <div
          className={`absolute right-10 mt-40 w-48 bg-light text-sm text-gray700 rounded-md z-50 ${menuClass}`}
          style={{ boxShadow: '1px 1px 8px 0px rgba(0, 0, 0, 0.15)' }}
        >
          <ul>
            <li
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                if (onDownloadXLS) {
                  onDownloadXLS();
                } else if (XLSParams) {
                  const { filename, headers, labels, columns } = XLSParams;
                  downloadXLS(filename, headers, labels, columns);
                }
                closeDropdown();
              }}
            >
              Download XLS
            </li>
            {!!imageParam && (
              <li
                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                onClick={() => {
                  downloadImage(imageParam);
                  closeDropdown();
                }}
              >
                Download PNG image
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DownloadMenu;
